import { toast } from "react-toastify";

// Centralized notifications helper to standardize usage across the app.
// Prefer inline validation and page-level banners for most cases.
// Use toasts sparingly for cross-flow confirmations, background task completions,
// clipboard actions, or non-blocking alerts that are not already obvious from the UI.

const defaultOptions = {
  position: "top-right",
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  theme: "light",
};

export const notify = {
  success(message, options = {}) {
    return toast.success(message, { ...defaultOptions, ...options });
  },

  error(message, options = {}) {
    return toast.error(message, {
      ...defaultOptions,
      autoClose: 5000,
      ...options,
    });
  },

  info(message, options = {}) {
    return toast.info(message, { ...defaultOptions, ...options });
  },

  warning(message, options = {}) {
    return toast.warning(message, {
      ...defaultOptions,
      autoClose: 5000,
      ...options,
    });
  },

  fromError(error, fallbackMessage = "Something went wrong", options = {}) {
    const message =
      typeof error === "string" ? error : error?.message || fallbackMessage;
    return toast.error(message, {
      ...defaultOptions,
      autoClose: 5000,
      ...options,
    });
  },
};

export default notify;

